// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__UU3Gd"};